import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { CheckIcon, XIcon, ChevronDownIcon, ChevronUpIcon, ShieldCheckIcon, LockIcon, ZapIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { PricingCard } from '../components/pricing/PricingCard';
import { ECommerceComparisonTable } from '../components/pricing/ECommerceComparisonTable';
export function ECommerce() {
  const [tableExpanded, setTableExpanded] = useState(false);
  const [currentShopIndex, setCurrentShopIndex] = useState(0);
  const toggleTable = () => {
    setTableExpanded(!tableExpanded);
  };
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleESilverClick = () => {
    window.open('https://buy.stripe.com/bJeeV7b6AgYSfXA7oAaZi03', '_blank');
  };
  const handleEGoldClick = () => {
    window.open('https://buy.stripe.com/4gMaER0rWcICfXA6kwaZi04', '_blank');
  };
  const handleEPlatinumClick = () => {
    window.open('https://buy.stripe.com/eVqbIVcaE9wq9zc8sEaZi05', '_blank');
  };
  const shopExamples = [{
    name: 'ooOhMy.co.uk',
    category: 'Ladies Fashion',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pQKeoA3T9GzSKJQNGTdgoz/websites_1_-_ooOhmy.co.uk.jpg',
    url: 'https://ooohmy.co.uk'
  }, {
    name: 'Fashion Boutique',
    category: 'Retail Fashion',
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    url: '#'
  }, {
    name: 'Tech Store',
    category: 'Electronics',
    image: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    url: '#'
  }];
  const handlePrevShop = () => {
    setCurrentShopIndex(prev => prev === 0 ? shopExamples.length - 1 : prev - 1);
  };
  const handleNextShop = () => {
    setCurrentShopIndex(prev => prev === shopExamples.length - 1 ? 0 : prev + 1);
  };
  return <>
      <Helmet data-id="element-1361">
        <title data-id="element-1362">
          E-commerce Websites UK | WooCommerce Stores from £699 Ex VAT
        </title>
        <meta name="description" content="Unlimited products, secure payments and analytics. Fixed-price WooCommerce builds for UK brands." data-id="element-1363" />
      </Helmet>
      {/* Hero Section */}
      <section className="pt-[clamp(56px,8vw,72px)] pb-16 bg-gradient-to-b from-[#0C1B26] to-[#212C34]" data-id="element-1364">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1365">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1366">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-1367">
              E-commerce Stores Built for Success
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg md:text-xl text-white/90 mb-8" data-id="element-1368">
              Shopping websites for retail brands – fashion, toys, tech and
              more. We build conversion-focused e-commerce websites that offer
              exceptional user experiences, robust SEO foundations, and seamless
              payment processing.
            </motion.p>
          </div>
        </div>
      </section>
      {/* Shop Examples Carousel */}
      <section className="py-16 bg-white dark:bg-[#1E1E1E]" data-id="element-1369">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1370">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1371">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1372">
              Our E-commerce Projects
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-1373">
              See examples of successful online stores we've built
            </motion.p>
          </div>
          <div className="relative max-w-4xl mx-auto" data-id="element-1374">
            <motion.div key={currentShopIndex} initial={{
            opacity: 0,
            x: 100
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -100
          }} transition={{
            duration: 0.3
          }} className="bg-[#212C34] rounded-xl overflow-hidden shadow-xl" data-id="element-1375">
              <img src={shopExamples[currentShopIndex].image} alt={`${shopExamples[currentShopIndex].name} e-commerce store`} className="w-full h-64 md:h-96 object-cover" data-id="element-1376" />
              <div className="p-6" data-id="element-1377">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-1378">
                  {shopExamples[currentShopIndex].name}
                </h3>
                <p className="text-white/80 mb-4" data-id="element-1379">
                  {shopExamples[currentShopIndex].category}
                </p>
                <a href={shopExamples[currentShopIndex].url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#0DC3DC] font-bold hover:text-[#0DC3DC]/80 transition-colors" data-id="element-1380">
                  Visit Store →
                </a>
              </div>
            </motion.div>
            <button onClick={handlePrevShop} className="absolute left-2 md:-left-12 top-1/2 transform -translate-y-1/2 bg-white dark:bg-[#1E1E1E] p-3 rounded-full shadow-lg hover:scale-110 transition-transform" aria-label="Previous shop" data-id="element-1381">
              <ChevronLeftIcon size={24} className="text-[#0DC3DC]" data-id="element-1382" />
            </button>
            <button onClick={handleNextShop} className="absolute right-2 md:-right-12 top-1/2 transform -translate-y-1/2 bg-white dark:bg-[#1E1E1E] p-3 rounded-full shadow-lg hover:scale-110 transition-transform" aria-label="Next shop" data-id="element-1383">
              <ChevronRightIcon size={24} className="text-[#0DC3DC]" data-id="element-1384" />
            </button>
          </div>
          <div className="flex justify-center mt-6 gap-2" data-id="element-1385">
            {shopExamples.map((_, index) => <button key={index} onClick={() => setCurrentShopIndex(index)} className={`w-3 h-3 rounded-full transition-all ${currentShopIndex === index ? 'bg-[#0DC3DC] w-8' : 'bg-gray-300 dark:bg-gray-700'}`} aria-label={`Go to shop ${index + 1}`} data-id="element-1386" />)}
          </div>
        </div>
      </section>
      {/* Pricing Cards Section */}
      <section className="py-16 md:py-24 bg-[#F9FAFB] dark:bg-[#121212]" data-id="element-1387">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1388">
          <div className="max-w-7xl mx-auto" data-id="element-1389">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1390">
              <PricingCard title="E-Silver" subtitle="Essential Store" price="£838.80" popular={false} features={['Unlimited products', 'PayPal/Stripe integration', 'Blog functionality', 'Basic product search', '3-month hosting included', '24/7 ticket support']} iconSrc="https://images.unsplash.com/photo-1601924582970-9238bcb495d9?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" iconAlt="ALT: E-Silver e-commerce plan badge" ctaText="Get Started" onClick={handleESilverClick} data-id="element-1391" />
              <PricingCard title="E-Gold" subtitle="Growing Business" price="£1,195.20" popular={true} features={['All E-Silver features', 'Abandoned cart recovery', 'Newsletter integration', 'Wishlist functionality', 'Social login options', '1-to-1 training session']} iconSrc="https://images.unsplash.com/photo-1610375461369-d613b564f4c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" iconAlt="ALT: E-Gold e-commerce plan badge" ctaText="★ Most Popular" onClick={handleEGoldClick} data-id="element-1392" />
              <PricingCard title="E-Platinum" subtitle="Enterprise Solution" price="£1,796.40" popular={false} features={['All E-Gold features', 'Advanced analytics', 'Subscriptions & recurring', 'Gift cards functionality', 'Product bundles/upsells', 'Custom functionality']} iconSrc="https://images.unsplash.com/photo-1614028674026-a65e31bfd27c?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" iconAlt="ALT: E-Platinum e-commerce plan badge" ctaText="Get Started" onClick={handleEPlatinumClick} data-id="element-1393" />
            </div>
            <div className="mt-12 text-center" data-id="element-1394">
              <button onClick={toggleTable} className="inline-flex items-center justify-center mx-auto px-8 py-3 rounded-full font-medium text-[15px] text-[#0DC3DC] bg-transparent border border-[#0DC3DC] border-opacity-40 hover:bg-gradient-to-r hover:from-[#0DC3DC] hover:to-[#00A8BF] hover:text-white hover:border-opacity-0 transition-all duration-300 shadow-sm hover:shadow-lg" style={{
              fontFamily: 'Poppins, sans-serif',
              minHeight: '46px'
            }} data-id="element-1395">
                <span className="mr-2" data-id="element-1396">
                  {tableExpanded ? 'Hide detailed comparison' : 'Show detailed comparison'}
                </span>
                {tableExpanded ? <ChevronUpIcon size={16} data-id="element-1397" /> : <ChevronDownIcon size={16} data-id="element-1398" />}
              </button>
            </div>
            {/* Comparison Table */}
            {tableExpanded && <ECommerceComparisonTable data-id="element-1399" />}
          </div>
        </div>
      </section>
      {/* Security & Trust Section */}
      <section className="py-16 md:py-24 bg-white dark:bg-[#1E1E1E]" data-id="element-1400">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1401">
          <div className="max-w-4xl mx-auto" data-id="element-1402">
            <div className="text-center mb-16" data-id="element-1403">
              <motion.h2 initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1404">
                Your Customers' Security Is Our Priority
              </motion.h2>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-1405">
                We implement industry-leading security measures to protect your
                store and customer data.
              </motion.p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-1406">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="bg-[#212C34] p-8 rounded-xl shadow-md text-center" data-id="element-1407">
                <div className="w-16 h-16 mx-auto bg-[#0DC3DC]/20 rounded-full flex items-center justify-center mb-4" data-id="element-1408">
                  <LockIcon size={32} className="text-[#0DC3DC]" data-id="element-1409" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1410">
                  SSL Security
                </h3>
                <p className="text-white/90" data-id="element-1411">
                  Every store comes with SSL certification, ensuring all
                  customer data is encrypted and secure.
                </p>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="bg-[#212C34] p-8 rounded-xl shadow-md text-center" data-id="element-1412">
                <div className="w-16 h-16 mx-auto bg-[#0DC3DC]/20 rounded-full flex items-center justify-center mb-4" data-id="element-1413">
                  <ShieldCheckIcon size={32} className="text-[#0DC3DC]" data-id="element-1414" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1415">
                  PCI Compliance
                </h3>
                <p className="text-white/90" data-id="element-1416">
                  Our payment gateways adhere to PCI DSS standards, protecting
                  card data and reducing your liability.
                </p>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-[#212C34] p-8 rounded-xl shadow-md text-center" data-id="element-1417">
                <div className="w-16 h-16 mx-auto bg-[#0DC3DC]/20 rounded-full flex items-center justify-center mb-4" data-id="element-1418">
                  <ZapIcon size={32} className="text-[#0DC3DC]" data-id="element-1419" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-1420">
                  Performance & CDN
                </h3>
                <p className="text-white/90" data-id="element-1421">
                  Optimized for speed with global CDN options to ensure fast
                  loading times for customers worldwide.
                </p>
              </motion.div>
            </div>
            {/* Trust Icons */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="flex flex-wrap justify-center items-center gap-8" data-id="element-1422">
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300" data-id="element-1423">
                <LockIcon size={24} className="text-[#0DC3DC]" data-id="element-1424" />
                <span className="font-medium" data-id="element-1425">SSL Secured</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300" data-id="element-1426">
                <img src="https://images.unsplash.com/photo-1614064641938-3bbee52942c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80" alt="Stripe payment gateway" className="h-8" data-id="element-1427" />
                <span className="font-medium" data-id="element-1428">Stripe</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-300" data-id="element-1429">
                <img src="https://images.unsplash.com/photo-1633265486064-086b219458ec?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80" alt="PayPal payment gateway" className="h-8" data-id="element-1430" />
                <span className="font-medium" data-id="element-1431">PayPal</span>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-[#F9FAFB] dark:bg-[#121212]" data-id="element-1432">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1433">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1434">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="mb-8" data-id="element-1435">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" alt="Bright Pixxel Studio - Affordable, Creative, Digital Excellence" className="h-16 mx-auto" data-id="element-1436" />
            </motion.div>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1437">
              Ready to launch your online store?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-1438">
              Get in touch today for a free consultation. We'll discuss your
              product range, business goals, and help you choose the perfect
              e-commerce solution.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} data-id="element-1439">
              <Button size="lg" onClick={scrollToContact} data-id="element-1440">
                Start Selling Online
              </Button>
            </motion.div>
          </div>
        </div>
      </section>
    </>;
}